import { forwardRef } from 'react';
import { cva, cx } from 'class-variance-authority';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';

type WellTypeMap = BaseTypeMap<'div', { transparent?: boolean }>;

export type WellProps = ComponentProps<WellTypeMap>;

export const well = cva(['overflow-hidden', 'rounded-lg'], {
  variants: {
    transparent: {
      true: ['bg-transparent'],
      false: ['bg-blue-50'],
    },
  },
  defaultVariants: {
    transparent: false,
  },
});

export const Well: Component<WellTypeMap> = forwardRef(function Well(
  { children, className, transparent, ...rest },
  ref
) {
  return (
    <Box ref={ref} className={cx(well({ transparent }), className)} {...rest}>
      <Box className="px-4 py-5 sm:p-6">{children}</Box>
    </Box>
  );
});
